module.exports = {
  title: 'Family Number Input with Reanimated',
  author: 'Enzo Manuel Mangano',
  date: '2024-01-17',
  slug: 'family-number-input',
  tags: ['reanimated', 'gesture-handler'],
};
